import React, { useContext, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import { Dropdown } from '@ikea-ux/dropdown';
// import { DropdownItem } from '@ikea-ux/dropdown';
// import '@ikea-ux/svg-icon/dist/style.css';
// import '@ikea-ux/forms/dist/style.css';
// import '@ikea-ux/inline-text/dist/style.css';
// import chevronDown from '@ingka/ssr-icon/paths/chevron-down-small';
// import SSRIcon from '@ingka/ssr-icon';
// import Modal, {
//   Sheets,
//   ModalHeader,
//   ModalFooter,
//   ModalBody
// } from '@ingka/modal';

import '@ingka/svg-icon/dist/style.css';
import '@ingka/forms/dist/style.css';
// import { Select, Option, OptGroup } from '@ingka/select';
// import ListView, { ListViewItem } from "@ingka/list-view";
import { getPathForLanguage } from '../components/util/language';
import DataContext from './DataContext/DataContext';
// import theme from './ui/theme';
// import Button from './ui/Button';

// const DropdownStyle = styled.div`
//   appearance: none;
//   -webkit-appearance: none;
//   -moz-appearance: none;

//   width: 20%;
//   font-size: 1rem;
//   font-weight: 400;

//   background: #025ca9;
//   select {
//     width: 100%;
//     color: #fff;
//     outline: none;
//     background: #025ca9;
//     padding: 8px;
//     border: 1px solid #fff;
//     border-radius: 5px;
//     font-size: 1rem;
//     font-weight: 400;
//   }
//   select option {
//     color: #fff;
//     border: none;
//     font-size: 1.4rem;
//     background: #025ca9;
//     padding: 0px;
//   }
// `;

function getSubpath() {
  const segments = window.location.pathname.split('/').slice(4);
  return segments.length === 0 ? '' : `${segments.join('/')}`;
}

const DropDownController = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    config,
    org,
    //setMarket,
    setMarketLanguage,
    language,
    setLang,
    modalOpen,
    setModalOpen
  } = useContext(DataContext);
  const dropdownRef = useRef(null);





useEffect(() => {
  const segments = location.pathname.split('/');
  const marketCode = segments[2]; // Assuming market is in the second segment
  const languageCode = segments[3]; // Assuming language is in the third segment

  setLang(languageCode); // Sync the language in the dropdown
  //setMarket(marketCode); // Sync the market in the context
  setMarketLanguage(languageCode); // Update market-language settings
}, [location]);


  // Sync dropdown state with URL when component mounts
  useEffect(() => {
    const segments = window.location.pathname.split('/');
    const marketCode = segments[2]; // Assuming market is in the second segment
    const languageCode = segments[3]; // Assuming language is in the third segment

    setLang(languageCode); // Set the initial language
    //setMarket(marketCode); // Set the initial market
    setMarketLanguage(languageCode); // Update market-language settings
  }, []);

  useEffect(() => {
    const handleOutsideClick = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && (event.target.className !== 'select-btn')) {
        if (event.target.className === 'imageStyle' || event.target.className === 'select-opt' || event.target.className === 'sBtn-text') {
          return;
        }
        setModalOpen(false); // Close the dropdown if clicked outside
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick); // Cleanup event listener on unmount
    };
  }, []);

 const switchLanguage = (event, languageCode) => {
  const languagePath = getPathForLanguage(languageCode);
  const subpath = getSubpath();
  const url = `/dppsi/${org}/${languagePath}/${subpath}`;
  navigate(url); // ✅ updated
  setLang(languagePath);
  setMarketLanguage(languagePath);
  setModalOpen(false);
};


  const findLangaugeDisplayLabel = languageCode => {
    const languageItem =
      config.languageDisplayLabels &&
      config.languageDisplayLabels.find(
        item => item.languageCode === languageCode
      );
    return languageItem ? languageItem.displayLabel : languageCode;
  };

  if (
    !config ||
    !config.ifoodPPSILanguageCodes ||
    config.ifoodPPSILanguageCodes.length < 2
  ) {
    return null;
  }

  const languageDisplay = config && config.ifoodPPSILanguageCodes.filter(i => i !== language)

  return (
    <div ref={dropdownRef}>
      {modalOpen && (
        <ul className="options">
          {languageDisplay.map((languageCode, index) => (
            <li
              className="option"
              key={index}
              value={languageCode}
              onClick={event => switchLanguage(event, languageCode)}
            >
              <img className="imageStyle" src={`/${languageCode}.png`} alt=""/>
              <span className="sBtn-text">
                {`${findLangaugeDisplayLabel(languageCode)}`}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DropDownController;
